export var Feature = 'Feature';
export var FeatureCollection = 'FeatureCollection';
export var MultiPoint = 'MultiPoint';
